(function () {
  if (window.__sqCorp) return;
  window.__sqCorp = true;
  function init() {
    var secs = document.querySelectorAll('.sqc');
    if (!secs.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    secs.forEach(function (s) { s.classList.add('is-js'); });

    var rot = document.querySelector('[data-sq-rot]');
    if (rot && !reduce) {
      var words = rot.getAttribute('data-sq-rot').split('|'), i = 0;
      if (words.length > 1) setInterval(function () {
        rot.classList.add('is-out');
        setTimeout(function () { i = (i + 1) % words.length; rot.textContent = words[i]; rot.classList.remove('is-out'); }, 280);
      }, 2400);
    }

    var items = document.querySelectorAll('.sqc-rv');
    if ('IntersectionObserver' in window && !reduce) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { threshold: 0.12 });
      items.forEach(function (el) { io.observe(el); });
    } else {
      items.forEach(function (el) { el.classList.add('is-in'); });
    }

    var form = document.getElementById('sq-corp-form');
    if (form) {
      var steps = form.querySelectorAll('[data-sq-step]');
      var prog = form.querySelector('[data-sq-prog]');
      var next = form.querySelector('[data-sq-next]');
      var back = form.querySelector('[data-sq-back]');
      var submit = form.querySelector('[data-sq-submit]');
      var cur = 0;
      if (steps.length && prog && next && back && submit) {
        prog.hidden = false;
        var bar = prog.querySelector('i');
        var labels = prog.querySelectorAll('li');
        var show = function () {
          steps.forEach(function (s, n) { s.hidden = n !== cur; });
          labels.forEach(function (l, n) { l.classList.toggle('is-on', n <= cur); });
          bar.style.width = ((cur + 1) / steps.length * 100) + '%';
          back.hidden = cur === 0;
          next.hidden = cur === steps.length - 1;
          submit.hidden = cur !== steps.length - 1;
        };
        var valid = function () {
          var fs = steps[cur].querySelectorAll('input,select,textarea');
          for (var k = 0; k < fs.length; k++) { if (!fs[k].checkValidity()) { fs[k].reportValidity(); return false; } }
          return true;
        };
        next.addEventListener('click', function () { if (valid() && cur < steps.length - 1) { cur++; show(); } });
        back.addEventListener('click', function () { if (cur > 0) { cur--; show(); } });
        show();
      }
    }

    var sticky = document.querySelector('[data-sq-sticky]');
    var heroCta = document.querySelector('[data-sq-hero-cta]');
    var formBox = document.getElementById('cotizar');
    if (sticky && heroCta && formBox && 'IntersectionObserver' in window) {
      var vis = { hero: true, form: false };
      var upd = function () { sticky.hidden = vis.hero || vis.form; };
      new IntersectionObserver(function (es) { vis.hero = es[0].isIntersecting; upd(); }).observe(heroCta);
      new IntersectionObserver(function (es) { vis.form = es[0].isIntersecting; upd(); }).observe(formBox);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
